export interface TimerSnapshot {
  category: string
  startTime: number
}

export interface AppSettings {
  theme: 'light' | 'dark' | 'system'
}

export interface OfflineRecord {
  category: string
  start_time: number
  end_time: number
  duration: number
  details?: Record<string, string>
  timestamp: number
}

const KEYS = {
  DEVICE_ID: 'device_id',
  AUTH_TOKEN: 'auth_token',
  TIMER_SNAPSHOT: 'timer_snapshot',
  APP_SETTINGS: 'app_settings',
  OFFLINE_QUEUE: 'offline_queue',
  DISMISSED_PWA_BANNER: 'dismissed_pwa_banner',
} as const

export const storage = {
  getDeviceId(): string | null {
    return localStorage.getItem(KEYS.DEVICE_ID)
  },
  setDeviceId(id: string): void {
    localStorage.setItem(KEYS.DEVICE_ID, id)
  },
  getAuthToken(): string | null {
    return localStorage.getItem(KEYS.AUTH_TOKEN)
  },
  setAuthToken(token: string): void {
    localStorage.setItem(KEYS.AUTH_TOKEN, token)
  },
  getTimerSnapshot(): TimerSnapshot | null {
    const raw = localStorage.getItem(KEYS.TIMER_SNAPSHOT)
    if (!raw) return null
    try { return JSON.parse(raw) } catch { return null }
  },
  setTimerSnapshot(snapshot: TimerSnapshot | null): void {
    if (snapshot) {
      localStorage.setItem(KEYS.TIMER_SNAPSHOT, JSON.stringify(snapshot))
    } else {
      localStorage.removeItem(KEYS.TIMER_SNAPSHOT)
    }
  },
  getSettings(): AppSettings {
    const raw = localStorage.getItem(KEYS.APP_SETTINGS)
    const defaults: AppSettings = { theme: 'system' }
    if (!raw) return defaults
    try { return { ...defaults, ...JSON.parse(raw) } } catch { return defaults }
  },
  setSettings(settings: AppSettings): void {
    localStorage.setItem(KEYS.APP_SETTINGS, JSON.stringify(settings))
  },
  getOfflineQueue(): OfflineRecord[] {
    const raw = localStorage.getItem(KEYS.OFFLINE_QUEUE)
    if (!raw) return []
    try { return JSON.parse(raw) } catch { return [] }
  },
  addToOfflineQueue(record: OfflineRecord): void {
    const queue = this.getOfflineQueue()
    if (queue.length >= 100) return
    queue.push(record)
    localStorage.setItem(KEYS.OFFLINE_QUEUE, JSON.stringify(queue))
  },
  clearOfflineQueue(): void {
    localStorage.removeItem(KEYS.OFFLINE_QUEUE)
  },
  getDismissedPwaBanner(): boolean {
    return localStorage.getItem(KEYS.DISMISSED_PWA_BANNER) === 'true'
  },
  setDismissedPwaBanner(dismissed: boolean): void {
    localStorage.setItem(KEYS.DISMISSED_PWA_BANNER, String(dismissed))
  },
}
